import React from 'react';

import { useSelector } from '@lumapps/redux/react';
import { DelayedSuspense } from '@lumapps/utils/components/DelayedSuspense';

import { GdprBanner as OldGdprBanner } from './components/GdprBannerOld';
import { isDiscoverAlphaEnabled, isGDPRBannerEnabled } from './ducks/selectors';

const NewGdprBanner = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'gdpr-banner' */
            './components/GdprBanner'
        ),
);

export const GdprBanner: React.FC<any> = (props) => {
    const isDiscoverAlphaFeatureEnabled = useSelector(isDiscoverAlphaEnabled);
    const isGDPRBannerFeatureEnabled = useSelector(isGDPRBannerEnabled);

    return isDiscoverAlphaFeatureEnabled ? (
        <DelayedSuspense shouldLoad={isGDPRBannerFeatureEnabled}>
            <NewGdprBanner {...props} />
        </DelayedSuspense>
    ) : (
        <OldGdprBanner />
    );
};
